export const ALL_COUNTRY = 'allCountry';
export const ALL_STATES = 'allStates';
